import { atom, useAtom } from 'jotai'
import { useEffect } from 'react'

const checkedNumAtom = atom(0)

export const useCheckedNum = () => {
  const atom = useAtom(checkedNumAtom)
  const [, setCheckedNum] = atom

  useEffect(() => {
    return () => setCheckedNum(0)
  }, [])

  return atom
}
